import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Features from './Features';
import HowItWorks from './HowItWorks';
import AppComingSoon from './AppComingSoon';
import Footer from './Footer';

const LandingPage = () => {

  setInterval(() => {
    fetch("https://api-manager-b7jc.onrender.com/health").catch(() => {});
  }, 1000 * 60 * 19); // every 19 minutes


  return (
    <div className="bg-offwhite text-charcoal antialiased">
      <Header />
      <Hero />
      <Features />
      <HowItWorks />
      <AppComingSoon />
      <Footer />
    </div>
  );
};

export default LandingPage;